import { render, staticRenderFns } from "./IngredientForm.vue?vue&type=template&id=3d654f1e&"
import script from "./IngredientForm.vue?vue&type=script&lang=ts&"
export * from "./IngredientForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports